import React, { ComponentType, FC } from 'react';
import { ToastContainer, ToastContainerProps, cssTransition, toast } from 'react-toastify';

import SVG from '../atoms/SVG';

const Zoom: ComponentType = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: 500,
  appendPosition: false,
});

interface ICloseButtonProps {
  closeToast?: () => void;
}

const CloseButton: FC<ICloseButtonProps> = ({ closeToast }) => (
  <div
    className="flex items-center justify-center Toastify__close-button cursor-pointer"
    role="presentation"
    onClick={closeToast}
  >
    <SVG src="images/global/icons/16/close.svg" title="Close" />
  </div>
);

const options: ToastContainerProps = {
  position: toast.POSITION.TOP_CENTER,
  draggable: false,
  hideProgressBar: true,
  closeButton: <CloseButton />,
  transition: Zoom,
  toastClassName: 'shadow-2',
};

const Toast = () => <ToastContainer {...options} />;

export default Toast;
